import React, { useState, useRef, useEffect } from "react";
import { Row, Tag } from "antd";
import { PlaySquareOutlined } from "@ant-design/icons";
import moment from "moment";
import { Link } from "react-router-dom";
import { toUpper } from "lodash";
import Truncate from "../Truncate/Truncate";
import { l } from "../../libs/localization";
import BrandModal from "../../pages/brand/brand.modal";

const CreaItem = ({ item }) => {
  const containerRef = useRef(null);
  const [containerWidth, setContainerWidth] = useState(0);
  const [showBrandModal, setShowBrandModal] = useState(false);
  const [brandId, setBrandId] = useState(null);

  useEffect(() => {
    if (!containerRef.current) return;

    const observer = new ResizeObserver((entries) => {
      for (let entry of entries) {
        setContainerWidth(entry.contentRect.width);
      }
    });

    observer.observe(containerRef.current);
    return () => observer.disconnect();
  }, []);

  const isCompact = containerWidth > 0 && containerWidth < 500;

  const renderImage = (c, fullWidth = false) =>
    c.snapshot_url ? (
      <Row
        align="middle"
        justify="center"
        className="customCard__crea-image customCard__crea-image--detail"
        style={{
          backgroundImage: `url(${c.snapshot_url})`,
          width: fullWidth ? "100%" : undefined,
          maxHeight: isCompact && fullWidth ? "160px" : undefined,
          margin: fullWidth ? "0 0 15px 0" : undefined,
        }}
      >
        <a href={c.url} target="_blank" rel="noreferrer">
          <PlaySquareOutlined
            className="customCard__crea-image--play"
            style={isCompact ? { fontSize: "2rem" } : {}}
          />
        </a>
      </Row>
    ) : (
      <Row
        align="middle"
        justify="center"
        className="customCard__crea-placeholder customCard__crea-placeholder--detail"
        style={{
          width: fullWidth ? "100%" : undefined,
          maxHeight: isCompact && fullWidth ? "120px" : undefined,
          margin: fullWidth ? "0 0 15px 0" : undefined,
        }}
      >
        <a href={c.url} target="_blank" rel="noreferrer">
          <PlaySquareOutlined
            className="customCard__crea-placeholder--play"
            style={isCompact ? { fontSize: "2rem" } : {}}
          />
        </a>
      </Row>
    );

  return (
    <div
      className="crea-item-container"
      ref={containerRef}
      style={{ width: "100%" }}
    >
      {isCompact && renderImage(item, true)}
      <div
        style={{ display: "flex", flexDirection: isCompact ? "column" : "row" }}
      >
        {!isCompact && (
          <div style={{ marginRight: "20px", minWidth: "300px" }}>
            {renderImage(item)}
          </div>
        )}
        <div style={{ flex: 1, minWidth: 0 }}>
          <Row
            justify="space-between"
            className={isCompact ? "px-2" : "px-3"}
            style={isCompact ? { flexDirection: "column" } : {}}
          >
            {isCompact ? (
              <div
                style={{
                  fontSize: "0.9rem",
                  fontWeight: "bold",
                  color: "var(--secondary)",
                  lineHeight: "1.2",
                  marginBottom: "4px",
                }}
              >
                {item.title}
              </div>
            ) : (
              <h3
                className="searchPage__item-title"
                style={{ marginBottom: "4px" }}
              >
                <b>{item.title}</b>
              </h3>
            )}
            <p
              style={
                isCompact
                  ? { fontSize: "0.7rem", color: "#888", marginBottom: "8px" }
                  : {}
              }
            >
              {item.date && moment(item.date).format("DD/MM/YYYY")}
            </p>
          </Row>
          <div
            className={isCompact ? "px-2" : "px-3"}
            style={isCompact ? { fontSize: "0.8rem" } : {}}
          >
            <div className="mb-2">
              {item.crea_category &&
                item.crea_category.map((cat, idx) => (
                  <Tag
                    key={idx}
                    style={
                      isCompact ? { fontSize: "0.7rem", padding: "0 4px" } : {}
                    }
                  >
                    {cat}
                  </Tag>
                ))}
            </div>
            <p
              style={
                isCompact ? { marginBottom: "8px", lineHeight: "1.3" } : {}
              }
            >
              <Truncate
                string={item.infos}
                truncateVal={isCompact ? 150 : 300}
              />
            </p>
            {item.agency && (
              <p style={isCompact ? { marginBottom: "4px" } : {}}>
                <b className="secondary">
                  {l("PAGES.COMPANIES.DETAIL.SECTIONS.AGENCIES")}:
                </b>{" "}
                <Link to={`/companies/${item.agency.id}`}>
                  {toUpper(item.agency.name)}
                </Link>
              </p>
            )}
            {item.production_agency && (
              <p style={isCompact ? { marginBottom: "4px" } : {}}>
                <b className="secondary">
                  {l("SCHEMA.DEFAULT.CREA.PRODUCTION_AGENCY")}:
                </b>{" "}
                <Link to={`/companies/${item.production_agency.id}`}>
                  {toUpper(item.production_agency.name)}
                </Link>
              </p>
            )}
            {item.brand && (
              <p style={isCompact ? { marginBottom: "4px" } : {}}>
                <b className="secondary">{l("PAGES.SEARCH.BRANDS")}:</b>{" "}
                <a
                  onClick={() => {
                    setBrandId(item.brand.id);
                    setShowBrandModal(true);
                  }}
                  className="pointer"
                >
                  {toUpper(item.brand.name)}
                </a>
              </p>
            )}
          </div>
        </div>
      </div>

      {brandId && (
        <BrandModal
          id={brandId}
          visible={showBrandModal}
          close={() => {
            setBrandId(null);
            setShowBrandModal(false);
          }}
        />
      )}
    </div>
  );
};

export default CreaItem;
